<!--
  @修改人: 谢汉 
  @修改时间：2019-12-05
  @修改描述：ALB目标组管理
  @版本:v2.0.11
-->
<template>
  <div class="ALBTargetGroupManager__content">
    <el-form ref="searchForm" :model="searchForm" :inline="true">
      <el-form-item input-width="auto">
        <g-select v-model="searchForm.group" :list="select_group"></g-select>
      </el-form-item>
      <el-form-item input-width="auto">
        <g-select v-model="searchForm.appName" :list="select_app"></g-select>
      </el-form-item>
      <el-form-item input-width="auto">
        <el-button type="primary"
          v-text="$t('common.search')"
          v-g-rac="gRac('ALBTargetGroupManager@search')"
          @click="search()"></el-button>
        <el-button type="primary"
          v-text="$t('ALBTargetGroupManager.relateGroup')"
          v-g-rac="gRac('ALBTargetGroupManager@relateGroup')"
          @click="relateDiaVis = true"></el-button>
      </el-form-item>
    </el-form>
    <div class="table-title" v-text="$t('ALBTargetGroupManager.onlineTitle')"></div>
    <el-table-extend
      :data="onlineTableData"
      :head="onlineTableHead"
      :currentChange="onlineCurrentChange"
      :sizeChange="onlineSizeChange"
      border>
      <template slot="control-column" slot-scope="{data}">
        <el-table-extend-control 
          :control="onlineTableControl" 
          :data="data"
          :label="$t('common.handle')">
        </el-table-extend-control>
      </template>
    </el-table-extend>
    <div style="margin: 10px 0;">
      <div class="table-title" v-text="$t('ALBTargetGroupManager.freeTitle')"></div>
      <el-button type="primary"
        v-text="$t('ALBTargetGroupManager.updateToGroup')"
        v-g-rac="gRac('ALBTargetGroupManager@updateToGroup')"
        @click="updateToGroup()"></el-button>
    </div>
    <el-table-extend
      :data="freeTableData"
      :head="freeTableHead"
      :currentChange="freeCurrentChange"
      :sizeChange="freeSizeChange"
      :selection="true" 
      :selectionChange="freeSelect"
      border>
    </el-table-extend>
    <div style="margin: 10px 0;">
      <div class="table-title" v-text="$t('ALBTargetGroupManager.offlineTitle')"></div>
      <el-button type="primary"
        v-text="$t('ALBTargetGroupManager.deleteFromGroup')"
        v-g-rac="gRac('ALBTargetGroupManager@deleteFromGroup')"
        @click="batchDeleteFromGroup()"></el-button>
    </div>
    <el-table-extend
      :data="offlineTableData"
      :head="offlineTableHead"
      :currentChange="offlineCurrentChange"
      :sizeChange="offlineSizeChange"
      :selection="true" 
      :selectionChange="offlineSelect"
      border>
    </el-table-extend>
    <el-dialog :closeOnClickModal="false"
      :title="$t('ALBTargetGroupManager.relateGroup')"
      :visible.sync="relateDiaVis"
      width="600px">
      <el-form ref="searchRelateForm" :model="searchRelateForm" :inline="true">
        <el-form-item input-width="auto">
          <g-select v-model="searchRelateForm.group" :list="select_group"></g-select>
        </el-form-item>
        <el-form-item input-width="auto">
          <g-select v-model="searchRelateForm.appName" :list="select_relateApp"></g-select>
        </el-form-item>
        <el-form-item input-width="auto">
          <el-button type="primary"
            v-text="$t('common.search')"
            @click="searchRelate()"></el-button>
        </el-form-item>
      </el-form>
      <el-transfer v-model="selecteds" :data="unselecteds"></el-transfer>
      <span slot="footer" class="dialog-footer">
        <el-button @click="relateDiaVis = false" v-text="$t('common.cancel')"></el-button>
        <el-button type="primary" v-text="$t('common.save')" @click="saveRelate"></el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
<script>
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import ALBTargetGroupManagerBiz from '@/logic/continuousDelivery/ALBTargetGroupManagerBiz'
  export default {
    mixins: [dic, rac],
    data () {
      return {
        selecteds: [],
        unselecteds: [],
        searchForm: {
          group: '',
          appName: ''
        },
        searchRelateForm: {
          group: '',
          appName: ''
        },
        select_relateApp: {},
        select_group: {},
        select_app: {},
        onlineTableData: {},
        onlineTableHead: [],
        onlineCurrentPage: 1,
        onlinePerPageCount: 10,
        onlineTableControl: [{
          rac: () => this.gRac('ALBTargetGroupManager@delete'),
          label: this.$t('common.delete'),
          callback: (row, index, data) => {
            this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
              confirmButtonText: this.$t('common.confirm'),
              cancelButtonText: this.$t('common.cancel'),
              type: 'warning'
            }).then(() => {
              ALBTargetGroupManagerBiz.deleteInstance({ id: row.id }).then((data) => {
                this.successMessage()
                this.searchOnlineTable()
                this.searchFreeTable()
                this.searchOffnlineTable()
              })
            }).catch(() => {})
          }
        }],
        freeTableData: {},
        freeTableHead: [],
        freeCurrentPage: 1,
        freePerPageCount: 10,
        freeTableSelect: [],
        offlineTableData: {},
        offlineTableHead: [],
        offlineCurrentPage: 1,
        offlinePerPageCount: 10,
        offlineTableSelect: [],
        relateDiaVis: false,
        select_targetGroup: []
      }
    },
    components: {},
    methods: {
      getGroup () {
        ALBTargetGroupManagerBiz.getGroup().then((data) => {
          this.select_group = {}
          if (data && data.length > 0) {
            data.map(item => {
              this.select_group[item] = item
            })
          }
          this.searchForm.group = Object.keys(this.select_group)[0]
          this.searchRelateForm.group = Object.keys(this.select_group)[0]
          this.initTable()
        })
      },
      getApp (group) {
        ALBTargetGroupManagerBiz.queryAppInfo({ group: group }).then((data) => {
          this.select_app = {}
          if (data && data.length > 0) {
            data.map(item => {
              this.select_app[item] = item
            })
          }
          this.searchForm.appName = Object.keys(this.select_app)[0]
        })
      },
      getRelateApp (group) {
        ALBTargetGroupManagerBiz.getApp({ group: group }).then((data) => {
          this.select_relateApp = {}
          if (data && data.length > 0) {
            data.map(item => {
              this.select_relateApp[item] = item
            })
          }
          this.searchRelateForm.appName = Object.keys(this.select_relateApp)[0]
        })
      },
      searchRelate () {
        ALBTargetGroupManagerBiz.getGroupRelateInfo({ ...this.searchRelateForm }).then((data) => {
          this.selecteds = data.selecteds
          this.unselecteds = []
          let allSelect = [ ...new Set([...data.selecteds, ...data.unselecteds]) ]
          allSelect.map(item => {
            this.unselecteds.push({
              key: item,
              label: item
            })
          })
        })
      },
      saveRelate () {
        ALBTargetGroupManagerBiz.saveGroupRelateInfo({ selecteds: this.selecteds, ...this.searchRelateForm }).then((data) => {
          this.successMessage()
        })
      },
      updateToGroup () {
        if (this.freeTableSelect && this.freeTableSelect.length > 0) {
          let selected = []
          this.freeTableSelect.map(item => {
            selected.push(item.id)
          })
          ALBTargetGroupManagerBiz.updateTargetGroup({ tagIds: selected }).then((data) => {
            this.successMessage()
            this.searchOnlineTable()
            this.searchFreeTable()
            this.searchOffnlineTable()
          })
        } else {
          this.$message({
            message: this.$t('ALBTargetGroupManager.selectTips'),
            type: 'warning'
          })
        }
      },
      batchDeleteFromGroup () {
        if (this.offlineTableSelect && this.offlineTableSelect.length > 0) {
          let selected = []
          this.offlineTableSelect.map(item => {
            selected.push(item.id)
          })
          ALBTargetGroupManagerBiz.batchDelete({ tagIds: selected }).then((data) => {
            this.successMessage()
            this.searchOnlineTable()
            this.searchFreeTable()
            this.searchOffnlineTable()
          })
        } else {
          this.$message({
            message: this.$t('ALBTargetGroupManager.selectTips'),
            type: 'warning'
          })
        }
      },
      initTable () {
        this.onlineTableHead = [
          { key: 'group',
            label: this.$t('ALBTargetGroupManager.onlineTable.group'),
            formatter: 'Dictionary',
            formatterDic: this.select_group },
          { key: 'appName', label: this.$t('ALBTargetGroupManager.onlineTable.appName') },
          { key: 'tag', label: this.$t('ALBTargetGroupManager.onlineTable.tag') },
          { key: 'ip', label: 'IP' },
          { key: 'port', label: this.$t('ALBTargetGroupManager.onlineTable.port') },
          { key: 'status', label: this.$t('ALBTargetGroupManager.onlineTable.status') },
          { key: 'instanceId', label: this.$t('ALBTargetGroupManager.onlineTable.instanceId') }
        ]
        this.freeTableHead = [
          { key: 'group',
            label: this.$t('ALBTargetGroupManager.onlineTable.group'),
            formatter: 'Dictionary',
            formatterDic: this.select_group },
          { key: 'appName', label: this.$t('ALBTargetGroupManager.onlineTable.appName') },
          { key: 'ip', label: 'IP' },
          { key: 'tag', label: this.$t('ALBTargetGroupManager.onlineTable.tag') },
          { key: 'instanceId', label: this.$t('ALBTargetGroupManager.onlineTable.instanceId') }
        ]
        this.offlineTableHead = [
          { key: 'group',
            label: this.$t('ALBTargetGroupManager.onlineTable.group'),
            formatter: 'Dictionary',
            formatterDic: this.select_group },
          { key: 'appName', label: this.$t('ALBTargetGroupManager.onlineTable.appName') },
          { key: 'tag', label: this.$t('ALBTargetGroupManager.onlineTable.tag') },
          { key: 'ip', label: 'IP' },
          { key: 'port', label: this.$t('ALBTargetGroupManager.onlineTable.port') },
          { key: 'instanceId', label: this.$t('ALBTargetGroupManager.onlineTable.instanceId') }
        ]
      },
      onlineCurrentChange (val) {
        this.onlineCurrentPage = val
        this.searchOnlineTable()
      },
      onlineSizeChange (val) {
        this.onlineCurrentPage = 1
        this.onlinePerPageCount = val
        this.searchOnlineTable()
      },
      freeCurrentChange (val) {
        this.freeCurrentPage = val
        this.searchFreeTable()
      },
      freeSizeChange (val) {
        this.freeCurrentPage = 1
        this.freePerPageCount = val
        this.searchFreeTable()
      },
      freeSelect (val) {
        this.freeTableSelect = val
      },
      offlineCurrentChange (val) {
        this.offlineCurrentPage = val
        this.searchOnlineTable()
      },
      offlineSizeChange (val) {
        this.offlineCurrentPage = 1
        this.offlinePerPageCount = val
        this.searchOnlineTable()
      },
      offlineSelect (val) {
        this.offlineTableSelect = val
      },
      searchOnlineTable () {
        let searchObj = {
          currentPage: this.onlineCurrentPage,
          perPageCount: this.onlinePerPageCount
        }
        ALBTargetGroupManagerBiz.queryOnlineInstance({ ...searchObj, ...this.searchForm }).then((data) => {
          this.onlineTableData = data
        })
      },
      searchFreeTable () {
        let searchObj = {
          currentPage: this.freeCurrentPage,
          perPageCount: this.freePerPageCount
        }
        ALBTargetGroupManagerBiz.queryFreeInstance({ ...searchObj, ...this.searchForm }).then((data) => {
          this.freeTableData = data
        })
      },
      searchOffnlineTable () {
        let searchObj = {
          currentPage: this.offlineCurrentPage,
          perPageCount: this.offlinePerPageCount
        }
        ALBTargetGroupManagerBiz.queryOfflineInstance({ ...searchObj, ...this.searchForm }).then((data) => {
          this.offlineTableData = data
        })
      },
      search () {
        this.onlineCurrentPage = 1
        this.onlinePerPageCount = 10
        this.offlineCurrentPage = 1
        this.offlinePerPageCount = 10
        this.searchOnlineTable()
        this.searchFreeTable()
        this.searchOffnlineTable()
      },
      successMessage () {
        this.$message({
          message: this.$t('common.success'),
          type: 'success'
        })
      }
    },
    watch: {
      'searchForm.group' () {
        this.getApp(this.searchForm.group)
      },
      'searchRelateForm.group' () {
        this.getRelateApp(this.searchRelateForm.group)
      }
    },
    mounted () {
      this.getGroup()
    }
  }
</script>
  
<style scoped>
  .table-title {
    display: inline-block;
    margin-right: 10px;
    font-weight: bold;
    font-size: 18px;
    padding: 10px 0;
  }
</style>